import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { Modal, Checkbox } from 'antd';
import { useState } from 'react';
import styles from './DownloadsPage.module.less';
import unrealIcon from 'assets/img/unreal-logo-icon.png';
import unityIcon from 'assets/img/unity-logo-icon.png';
import omniIcon from 'assets/img/omni-logo-icon-only.png';
import githubIcon from 'assets/img/github-logo-icon.png';
import SdkEula from './SdkEula';

export default function DownloadsPage() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	const [unityModalVisible, setUnityModalVisible] = useState(false);
	const [unrealModalVisible, setUnrealModalVisible] = useState(false);
	const [sdkButtonText, setSdkButtonText] = useState('Download SDK');
	const [chosenUnrealSdkVersion, setChosenUnrealSdkVersion] = useState('');

	const [unreal_sdk_assets] = useState({
		'4.27': {
			title: 'Omni One SDK for Unreal 4.27',
			description: 'Bring your Unreal content to Omni One.',
			downloadUrl: 'https://assets.omni.virtuix.com/sdk-assets/unreal-sdk/OmniConnectSDK_0.2.1_UE4.27.zip',
		},
		'5.3': {
			title: 'Omni One SDK for Unreal 5.3',
			description: 'Bring your Unreal content to Omni One.',
			downloadUrl: 'https://assets.omni.virtuix.com/sdk-assets/unreal-sdk/OmniConnectSDK_0.2.1_UE5.3.zip',
		},
		'5.4': {
			title: 'Omni One SDK for Unreal 5.4',
			description: 'Bring your Unreal content to Omni One.',
			downloadUrl: 'https://assets.omni.virtuix.com/sdk-assets/unreal-sdk/OmniConnectSDK_0.2.1_UE5.4.zip',
		},
		'5.5': {
			title: 'Omni One SDK for Unreal 5.5',
			description: 'Bring your Unreal content to Omni One.',
			downloadUrl: 'https://assets.omni.virtuix.com/sdk-assets/unreal-sdk/OmniConnectSDK_0.2.1_UE5.5.zip',
		},
	});

	// Show/Hide SDK EULA Modal for Unity SDK
	const showUnityEula = () => {
		setUnityModalVisible(true);
	};

	const hideUnityEula = () => {
		setUnityModalVisible(false);
	};

	const hideUnityEulaDelay = () => {
		setSdkButtonText('Your download will begin in a moment');
		setTimeout(() => {
			setUnityModalVisible(false);
		}, 2000);
		setTimeout(() => {
			setSdkButtonText('Download SDK');
		}, 2000);
	};

	// Switch state on click for Download Unity SDK button
	const [checkedUnity, setCheckedUnity] = useState(false);

	const handleCheckboxChangeUnity = () => {
		setCheckedUnity(!checkedUnity);
	};

	// Show/Hide SDK EULA Modal for Unreal SDK
	const showUnrealEula = (version) => {
		setChosenUnrealSdkVersion(version);
		setUnrealModalVisible(true);
	};

	const hideUnrealEula = () => {
		setUnrealModalVisible(false);
	};

	const hideUnrealEulaDelay = () => {
		setSdkButtonText('Your download will begin in a moment');
		setTimeout(() => {
			setUnrealModalVisible(false);
		}, 2000);
		setTimeout(() => {
			setSdkButtonText('Download SDK');
		}, 2000);
	};

	// Switch state on click for Download Unreal SDK button
	const [checkedUnreal, setCheckedUnreal] = useState(false);

	const handleCheckboxChangeUnreal = () => {
		setCheckedUnreal(!checkedUnreal);
	};

	return (
		<>
			<div className={styles.DownloadsPageContainer}>
				<h1 className={styles.DownloadsPageTitle}>Unity SDK</h1>
				<div className={styles.DownloadsPageDisplayRow}>
					<div className={styles.DownloadsPageDisplayColumn}>
						<div className={styles.DownloadsPageCard}>
							<div className={styles.DownloadsPageCardIconsTop}>
								<img src={omniIcon} className={styles.DownloadsPageCardIcon} />
								<img src={unityIcon} className={styles.DownloadsPageCardIcon} />
							</div>
							<p className={styles.DownloadsPageHeader}>Omni One SDK for Unity</p>
							<p>Bring your Unity content to Omni One.</p>
							<button className={styles.DownloadsPageButton} onClick={showUnityEula}>
								Download
							</button>
						</div>
					</div>
				</div>
				<h1 className={styles.DownloadsPageTitle}>Unreal SDK</h1>
				<div className={styles.DownloadsPageDisplayRow}>
					{Object.keys(unreal_sdk_assets).map((version) => (
						<div className={styles.DownloadsPageDisplayColumn} key={version}>
							<div className={styles.DownloadsPageCard}>
								<div className={styles.DownloadsPageCardIconsTop}>
									<img src={omniIcon} className={styles.DownloadsPageCardIcon} />
									<img src={unrealIcon} className={styles.DownloadsPageCardIcon} />
								</div>
								<p className={styles.DownloadsPageHeader}>{unreal_sdk_assets[version].title}</p>
								<p>{unreal_sdk_assets[version].description}</p>
								<button
									className={styles.DownloadsPageButton}
									onClick={() => {
										showUnrealEula(version);
									}}
								>
									Download
								</button>
							</div>
						</div>
					))}
				</div>
			</div>
			<Modal
				title="Omni One SDK - Read and Accept Terms"
				width={960}
				visible={unityModalVisible}
				footer={null}
				onCancel={hideUnityEula}
			>
				<SdkEula />
				<Checkbox checked={checkedUnity} onChange={handleCheckboxChangeUnity}>
					I agree to the terms and conditions
				</Checkbox>
				<br />
				<a
					href="https://assets.omni.virtuix.com/sdk-assets/unity-sdk/OmniConnectSDK_Unity_v0.1.2.zip"
					rel="noreferrer"
					download
				>
					<button className={styles.DownloadsPageButtonSdk} disabled={!checkedUnity} onClick={hideUnityEulaDelay}>
						{sdkButtonText}
					</button>
				</a>
			</Modal>
			<Modal
				title="Omni One SDK - Read and Accept Terms"
				width={960}
				visible={unrealModalVisible}
				footer={null}
				onCancel={hideUnrealEula}
			>
				<SdkEula />
				<Checkbox checked={checkedUnreal} onChange={handleCheckboxChangeUnreal}>
					I agree to the terms and conditions
				</Checkbox>
				<br />
				<a
					href={unreal_sdk_assets[chosenUnrealSdkVersion] && unreal_sdk_assets[chosenUnrealSdkVersion].downloadUrl}
					rel="noreferrer"
					download
				>
					<button className={styles.DownloadsPageButtonSdk} disabled={!checkedUnreal} onClick={hideUnrealEulaDelay}>
						{sdkButtonText}
					</button>
				</a>
			</Modal>
		</>
	);
}
